import { Box } from '@mui/material'
import { ReactComponent as ChartIcon } from 'assets/chart-icon.svg'
import { getDatesArray } from 'components/shared/processes'
import useLamenessInfoForChart from 'hook/query/useLamenessInfoForChart'
import { LamenessTypeChart } from 'models'
import moment from 'moment'
import { useState } from 'react'
import { CardStandart } from 'ui/CardStandart'
import Preloader from 'ui/Preloader'
import TooltipHover from 'ui/TooltipHover'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'
import { ExpiredLicense } from 'ui/expired-license/ExpiredLicense'
import DefaultSelectForm from 'ui/menu/DefaultSelectForm'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import LamenessChart from '../shared/LamenessChart'

interface LamenessCardChartProps {
	groupIds?: string
}

const LamenessCardChart = ({ groupIds }: LamenessCardChartProps) => {
	const [selectTypeOfChart, setSelectTypeOfChart] = useState<LamenessTypeChart>(
		LamenessTypeChart.LamenessType,
	)
	const [chartMenuOpen, setChartMenuOpen] = useState(false)
	const [chartButtonHover, setChartButtonHover] = useState(false)
	const weekDays = getDatesArray(6)
	const [dateRange, setDateRange] = useState({
		startDate: weekDays.startDate,
		endDate: weekDays.endDate,
	})
	const { dotsInfo, isLoading, error } = useLamenessInfoForChart(
		dateRange,
		groupIds,
	)

	const onChangeCallback = value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
	}

	const menuDescription = [
		{
			description: 'По количеству хромых',
			value: LamenessTypeChart.LamenessType,
		},
		{
			description: 'По баллам',
			value: LamenessTypeChart.PointType,
		},
	]

	return (
		<CardStandart
			sx={{
				padding: '24px',
				display: 'flex',
				flexDirection: 'column',
				gap: '16px',
				minHeight: '500px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '8px',
				}}
			>
				<TypographyHeader>График хромоты</TypographyHeader>
				<Box
					onMouseEnter={() => setChartButtonHover(true)}
					onMouseLeave={() => setChartButtonHover(false)}
					onMouseDown={() => setChartMenuOpen(true)}
				>
					<TooltipHover
						title={'Изменить вид графика'}
						placement={'bottom-end'}
						disableHoverBackground
						open={chartButtonHover && !chartMenuOpen}
					>
						<DefaultSelectForm
							textTitle={<ChartIcon />}
							menuDescription={menuDescription}
							onClick={(value: string) =>
								setSelectTypeOfChart(value as LamenessTypeChart)
							}
							isArrow
							selectedMenu={[selectTypeOfChart]}
							active={selectTypeOfChart === LamenessTypeChart.PointType}
							onOpenChange={open => {
								setChartMenuOpen(open)
								if (!open) setChartButtonHover(false)
							}}
						/>
					</TooltipHover>
				</Box>
			</Box>
			<DateRangePicker
				onChangeUpdateDate={onChangeCallback}
				weekFilter={true}
				monthFilter={true}
				yearFilter={true}
				currentRange={'Неделя'}
				startDate={dateRange.startDate}
				endDate={dateRange.endDate}
			/>
			{isLoading ? (
				<Preloader mt={6} />
			) : error?.response.status === 450 ? (
				<ExpiredLicense
					mt={'80px'}
					availableLicenceDates={`Доступен просмотр данных за период ${moment(
						parseInt(error?.response.data.license_start, 10),
					).format('DD.MM.YY')} - ${moment(
						parseInt(error?.response.data.license_end, 10),
					).format('DD.MM.YY')}`}
				/>
			) : (
				<LamenessChart
					dotsInfo={dotsInfo}
					selectTypeOfChart={selectTypeOfChart}
				/>
			)}
		</CardStandart>
	)
}

export default LamenessCardChart
